const loadingLabel = "Зареждане";
const bgBG = {
  loadingLabel
};
export {
  bgBG as default,
  loadingLabel
};
